import PropTypes from 'prop-types';
import React from 'react';

import ToggleButton from './ToggleButton';

const SettingsToggleCell = ({title, enabled, onClick}) => (
  <div className="SettingsToggleCell">
    <p className="SettingsToggleCell__title">
      {title}
    </p>
    <ToggleButton enabled={enabled} onClick={onClick} />
  </div>
);

SettingsToggleCell.propTypes = {
  title: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SettingsToggleCell;



// WEBPACK FOOTER //
// ./src/components/SettingsToggleCell.js